import { kaylasClient } from "@/lib/kaylasAuth";

export const kaylasApi = {
  dashboard: () => kaylasClient.get("/kayla/dashboard").then((r) => r.data),
  // Tubers
  listTubers: () => kaylasClient.get("/kayla/tubers").then((r) => r.data),
  createTuber: (p) => kaylasClient.post("/kayla/tubers", p).then((r) => r.data),
  updateTuber: (id, p) => kaylasClient.put(`/kayla/tubers/${id}`, p).then((r) => r.data),
  deleteTuber: (id) => kaylasClient.delete(`/kayla/tubers/${id}`).then((r) => r.data),
  sendToBloom: (id) => kaylasClient.post(`/kayla/tubers/${id}/send-to-blooms`).then((r) => r.data),
  // Blooms
  listBlooms: () => kaylasClient.get("/kayla/blooms").then((r) => r.data),
  createBloom: (p) => kaylasClient.post("/kayla/blooms", p).then((r) => r.data),
  updateBloom: (id, p) => kaylasClient.put(`/kayla/blooms/${id}`, p).then((r) => r.data),
  deleteBloom: (id) => kaylasClient.delete(`/kayla/blooms/${id}`).then((r) => r.data),
  // Flowers
  listFlowers: () => kaylasClient.get("/kayla/flowers").then((r) => r.data),
  createFlower: (p) => kaylasClient.post("/kayla/flowers", p).then((r) => r.data),
  updateFlower: (id, p) => kaylasClient.put(`/kayla/flowers/${id}`, p).then((r) => r.data),
  deleteFlower: (id) => kaylasClient.delete(`/kayla/flowers/${id}`).then((r) => r.data),
  // Seeds
  listSeeds: () => kaylasClient.get("/kayla/seeds").then((r) => r.data),
  createSeed: (p) => kaylasClient.post("/kayla/seeds", p).then((r) => r.data),
  updateSeed: (id, p) => kaylasClient.put(`/kayla/seeds/${id}`, p).then((r) => r.data),
  deleteSeed: (id) => kaylasClient.delete(`/kayla/seeds/${id}`).then((r) => r.data),
  // Cross-record database
  database: (q, kind) => kaylasClient.get("/kayla/database", { params: { q, kind } }).then((r) => r.data),
  // Gardens (builder)
  listGardens: () => kaylasClient.get("/kayla/gardens").then((r) => r.data),
  createGarden: (p) => kaylasClient.post("/kayla/gardens", p).then((r) => r.data),
  updateGarden: (id, p) => kaylasClient.put(`/kayla/gardens/${id}`, p).then((r) => r.data),
  deleteGarden: (id) => kaylasClient.delete(`/kayla/gardens/${id}`).then((r) => r.data),
  duplicateGarden: (id) => kaylasClient.post(`/kayla/gardens/${id}/duplicate`).then((r) => r.data),
  addBed: (gid, p) => kaylasClient.post(`/kayla/gardens/${gid}/beds`, p).then((r) => r.data),
  updateBed: (gid, bid, p) => kaylasClient.put(`/kayla/gardens/${gid}/beds/${bid}`, p).then((r) => r.data),
  deleteBed: (gid, bid) => kaylasClient.delete(`/kayla/gardens/${gid}/beds/${bid}`).then((r) => r.data),
  placePlant: (gid, bid, p) => kaylasClient.post(`/kayla/gardens/${gid}/beds/${bid}/plants`, p).then((r) => r.data),
  updatePlant: (gid, bid, pid, p) => kaylasClient.put(`/kayla/gardens/${gid}/beds/${bid}/plants/${pid}`, p).then((r) => r.data),
  deletePlant: (gid, bid, pid) => kaylasClient.delete(`/kayla/gardens/${gid}/beds/${bid}/plants/${pid}`).then((r) => r.data),
  gardenSummary: (gid) => kaylasClient.get(`/kayla/gardens/${gid}/summary`).then((r) => r.data),
  // Wishlist
  listWishlist: () => kaylasClient.get("/kayla/wishlist").then((r) => r.data),
  createWish: (p) => kaylasClient.post("/kayla/wishlist", p).then((r) => r.data),
  updateWish: (id, p) => kaylasClient.put(`/kayla/wishlist/${id}`, p).then((r) => r.data),
  deleteWish: (id) => kaylasClient.delete(`/kayla/wishlist/${id}`).then((r) => r.data),
  // Tasks
  listTasks: () => kaylasClient.get("/kayla/tasks").then((r) => r.data),
  createTask: (p) => kaylasClient.post("/kayla/tasks", p).then((r) => r.data),
  updateTask: (id, p) => kaylasClient.put(`/kayla/tasks/${id}`, p).then((r) => r.data),
  deleteTask: (id) => kaylasClient.delete(`/kayla/tasks/${id}`).then((r) => r.data),
  taskSuggestions: () => kaylasClient.get("/kayla/tasks/suggestions").then((r) => r.data),
  // Journal
  listJournal: (q) => kaylasClient.get("/kayla/journal", { params: q ? { q } : {} }).then((r) => r.data),
  createJournal: (p) => kaylasClient.post("/kayla/journal", p).then((r) => r.data),
  deleteJournal: (id) => kaylasClient.delete(`/kayla/journal/${id}`).then((r) => r.data),
  // Photos
  photos: () => kaylasClient.get("/kayla/photos").then((r) => r.data),
};

export const fileToDataURL = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});
